import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';

import { SubmitButton } from 'src/app/shared/components/payments';

import { useShowPaypalButton } from '../hooks/useShowPaypalButton';
import { useMembershipModalState } from '../modalContext';

export function ContinueButton(): JSX.Element | null {
	const [{ formState, validationErrors }] = useMembershipModalState();
	const showPaypalButton = useShowPaypalButton();

	if (showPaypalButton) return null;

	const isLoading = formState?.status === 'loading';
	return (
		<SubmitButton
			loading={isLoading}
			disabled={isLoading || !!validationErrors}
			label={<Translate value="corgi.co.ppmu.modal.continue" />}
		/>
	);
}
